// Common "leave this out" ingredients for the profile's exclude picker.
//
// The `value` is canonical English: it is what the profile stores and what the
// backend's exclusion matcher runs against dish names and tags — so a guest
// reading Russian still excludes dishes from an English menu. Spellings follow
// the menu itself ("chilli", not "chili"): the value is only as strong as the
// substring it matches. Labels live in the i18n catalogs under
// `excludeIngredients.<key>`; free text alongside stays allowed.
export const EXCLUDE_INGREDIENTS = [
  { key: "onion", value: "onion" },
  { key: "garlic", value: "garlic" },
  { key: "chilli", value: "chilli" },
  { key: "mushroom", value: "mushroom" },
  { key: "tomato", value: "tomato" },
  { key: "cheese", value: "cheese" },
  { key: "avocado", value: "avocado" },
  { key: "egg", value: "egg" },
  { key: "coconut", value: "coconut" },
  { key: "butter", value: "butter" },
];
